// auto-generated by Typewriter template _enums.tst from PortCall.Models\Vessels\Vessel.cs
export enum VesselStatus { 
    Active = 0,
    Pending = 10,
    Inactive = 20
}

export const VesselStatusDisplayName : { [val : number] : string } = { 
    0: 'Active',
    10: 'Pending',
    20: 'Inactive'
}

export const VesselStatuses : { Id : VesselStatus, Name : string }[] = [ 
    { Id: VesselStatus.Active, Name: 'Active' },
    { Id: VesselStatus.Pending, Name: 'Pending' },
    { Id: VesselStatus.Inactive, Name: 'Inactive' }
]



// WEBPACK FOOTER //
// ./server/enums/VesselStatus.ts